import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
import Vue from 'vue';

Vue.component(FeatherIcon.name, FeatherIcon);
